<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import authMixin from "../../mixins/auth";

/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    mixins: [authMixin],
    props: {
        evento_id: {
            type: Number,
            required: true
        },
        laborante_id: {
            type: Number,
            required: true
        },
        evento_codigo: {
            type: String,
            default: ''
        },
        coordinador_evento: {
            type: String,
            default: ''
        },
        asociacion_finalizada: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            title: "Listado Encuesta",
            items: [
                {
                text: "Digitalización",
                href: "/"
                },
                {
                text: "Listado",
                active: true
                }
            ],
            imagenes:[],
            currentPage: 1,
            perPage: 20,
            pageOptions: [20, 40, 60, 80],
            filtro: '',
            showModalImagen: false,
            modalImagenUrl: '',
            modalRotacion: 0,
            isLoading: false,
            reenviandoIds: {},
            reprocesandoIds: {},
            reprocesandoTodos: false,
            asociacionFinalizada: false,
        };
    },
    computed:{
        // usar filteredData.length para paginado correcto
        rows() {
            return this.visibleData.length;
        },
        filteredData() {
            // Filtra y luego ordena: primero 'ActualizadoAWS', luego el resto
            return this.imagenes
                .filter((item) => {
                    const filtro = this.filtro.toLowerCase();
                    return (
                        (item.rut && item.rut.toLowerCase().includes(filtro)) ||
                        ((item.rbd_colegio || item.rbd) && String(item.rbd_colegio || item.rbd).toLowerCase().includes(filtro)) ||
                        (item.nombre_completo && item.nombre_completo.toLowerCase().includes(filtro)) ||
                        (item.fecha && item.fecha.toLowerCase().includes(filtro)) ||
                        (item.establecimiento && item.establecimiento.toLowerCase().includes(filtro)) ||
                        (item.curso && item.curso.toLowerCase().includes(filtro)) ||
                        (item.celular && item.celular.toLowerCase().includes(filtro)) ||
                        (item.email && item.email.toLowerCase().includes(filtro)) ||
                        (item.carrera && item.carrera.toLowerCase().includes(filtro)) ||
                        (item.tipo_mime && item.tipo_mime.toLowerCase().includes(filtro))
                    );
                })
                /*.sort((a, b) => {
                    // Ordena primero los que tienen tipo_mime 'ActualizadoAWS'
                    if (a.tipo_mime === 'ActualizadoAWS' && b.tipo_mime !== 'ActualizadoAWS') return -1;
                    if (a.tipo_mime !== 'ActualizadoAWS' && b.tipo_mime === 'ActualizadoAWS') return 1;
                    return 0;
                });*/
         },
        // visibleData contiene solo los registros pares (posición 1-based par: 2,4,6...)
        // cada entrada incluye el item original y su índice dentro de filteredData
        visibleData() {
            return this.filteredData
                .map((it, idx) => ({ item: it, origIndex: idx })) // idx es 0-based
                .filter(entry => {
                    // V2 y V3: cada registro es una ficha completa e independiente.
                    if ([2, 3].includes(Number(entry.item?.formulario_version))) return true;
                    // Clásico v1: conservar posiciones pares (1-based).
                    return ((entry.origIndex + 1) % 2) === 1;
                });
         },
         paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.visibleData.slice(start, end);
         },
         totalPages() {
            return Math.ceil(this.visibleData.length / this.perPage);
         },
         // todas las fichas (posiciones impares de imagenes), sin filtro de búsqueda
         allFichas() {
             return this.imagenes
                 .map((it, idx) => ({ item: it, origIndex: idx }))
                 .filter(entry => {
                     // V2 y V3: cada registro es una ficha completa e independiente.
                     if ([2, 3].includes(Number(entry.item?.formulario_version))) return true;
                     // Clásico v1: solo posiciones pares (delantera del par delantera+trasera).
                     return ((entry.origIndex + 1) % 2) === 1;
                 });
         },
         crmResumen() {
             const grupos = [
                 {
                     key: 'enviado_ok',
                     label: 'Exitoso',
                     variant: 'success',
                     title: 'Incluye: enviado_ok, reenviado_admin_exitoso. Casos enviados exitosamente al CRM.',
                     estados: ['enviado_ok', 'reenviado_admin_exitoso']
                 },
                 {
                     key: 'duplicado',
                     label: 'Duplicado',
                     variant: 'warning',
                     title: 'Incluye: duplicado, reenviado_admin_duplicado. Casos ya existentes en CRM.',
                     estados: ['duplicado', 'reenviado_admin_duplicado']
                 },
                 {
                     key: 'error_envio',
                     label: 'Con error',
                     variant: 'danger',
                     title: 'Incluye: error_envio, reenviado_admin_error. Fallas de envío/validación al CRM.',
                     estados: ['error_envio', 'reenviado_admin_error']
                 },
                 {
                     key: 'pendiente',
                     label: 'Pendiente',
                     variant: 'info',
                     title: 'Incluye: pendiente_envio, pendiente_envio_admin, pendiente_reenvio, reenvio_programado. Aún no finaliza envío a CRM.',
                     estados: ['pendiente_envio', 'pendiente_envio_admin', 'pendiente_reenvio', 'reenvio_programado']
                 },
                 {
                     key: 'no_aplica',
                     label: 'No aplica',
                     variant: 'dark',
                     title: 'No se envía al CRM. Puede incluir casos descartados, ignorados por validación, sin datos mínimos o excluidos por reglas.',
                     estados: ['no_aplica']
                 },
                 {
                     key: 'sin_preparar',
                     label: 'Sin preparar',
                     variant: 'secondary',
                     title: 'A la espera de revisión/manual de ficha antes de preparar envío a CRM.',
                     estados: ['sin_preparar']
                 },
             ];

             const counts = {};
             for (const grupo of grupos) counts[grupo.key] = 0;

             for (const entry of this.allFichas) {
                 const estado = entry.item.estado_crm || 'sin_preparar';
                 const grupo = grupos.find(g => g.estados.includes(estado));
                 if (grupo) {
                     counts[grupo.key]++;
                 }
             }

             return grupos.map(grupo => ({
                 key: grupo.key,
                 label: grupo.label,
                 variant: grupo.variant,
                 title: grupo.title,
                 count: counts[grupo.key] || 0,
             }));
         },
         accionesBloqueadasPorFinalizado() {
             if (this.asociacionFinalizada) return true;

             const filas = (this.imagenes || []).filter(r => r?.tipo_mime !== 'PlantillaAsistente');
             if (!filas.length) return false;

             const hayFlagFinalizar = filas.some(r => r?.finalizar !== undefined && r?.finalizar !== null);
             if (!hayFlagFinalizar) return false;

             return filas.every(r => Number(r?.finalizar || 0) === 1);
         },
     },
    methods: {
        cargarImagenes() {
            console.log(this.evento_id);
            console.log(this.laborante_id);
            this.isLoading = true;
            axios.get('/api/todas_imagenes_digitalizadas', {
                params: {
                    evento_id: this.evento_id,
                    laborante_id: this.laborante_id
                }
            })
            .then(response => {
                this.imagenes = response.data.imagenes || [];
                this.asociacionFinalizada = Boolean(response.data?.finalizada ?? this.asociacion_finalizada);
                for (let i = 0; i < this.imagenes.length; i++) {
                    // V2 y V3: cada registro es una ficha completa, no tiene trasera.
                    if ([2, 3].includes(Number(this.imagenes[i]?.formulario_version))) {
                        this.imagenes[i].imagen2 = null;
                        continue;
                    }
                    this.imagenes[i].imagen2 = this.imagenes[i + 1] ? this.imagenes[i + 1].url_publica : null;
                }
                if(this.imagenes.length === 0) {
                    this.$bvToast.toast('No hay más imágenes para revisar.', {
                        title: 'Información',
                        variant: 'info',
                        solid: true
                    });
                }
                this.isLoading = false;
            })
            .catch(error => {
                console.error('Error al cargar imágenes:', error);
                this.isLoading = false;
            });
        },
        abrirModalImagen(url) {
            this.modalImagenUrl = url;
            this.showModalImagen = true;
            this.modalRotacion = 0;
        },
        esPdfUrl(url) {
            if (!url) return false;
            const s = String(url);
            // PDF clásico (.pdf con query/fragmento opcional) o ruta v2 (/api/v2/ficha-pdf/{id}).
            return /\.pdf(\?|#|$)/i.test(s) || /\/ficha-pdf\//i.test(s);
        },
        rotarModalIzquierda() {
            this.modalRotacion = (this.modalRotacion - 90) % 360;
        },
        rotarModalDerecha() {
            this.modalRotacion = (this.modalRotacion + 90) % 360;
        },
        eliminarImagen(id) {
            if (this.asociacionFinalizada) {
                this.$bvToast.toast('La asociación está finalizada. No se pueden modificar ni eliminar fichas.', {
                    title: 'Acción bloqueada',
                    variant: 'warning',
                    solid: true
                });
                return;
            }
            //this.isLoading = true;
            this.$bvModal.msgBoxConfirm('¿Estás seguro que deseas eliminar esta imagen?', {
              title: 'Confirmar eliminación',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              okTitle: 'Eliminar',
              cancelTitle: 'Cancelar',
              footerClass: 'p-2',
              centered: true
            })
            .then(value => {
              if (value) {
                axios.post('/api/eliminar_imagen_digitalizada', { id })
                  .then(() => {
                    this.$bvToast.toast('Imagen eliminada correctamente', {
                      title: 'Eliminada',
                      variant: 'success',
                      solid: true
                    });
                    this.cargarImagenes();
                    //this.isLoading = false;
                  })
                  .catch(error => {
                    this.$bvToast.toast('Error al eliminar la imagen', {
                      title: 'Error',
                      variant: 'danger',
                      solid: true
                    });
                    console.error(error);
                    //this.isLoading = false;
                  });
              } else {
                //this.isLoading = false;
              }
            });
          },
                canRedigitalizarRegistro(item) {
                    if (!item) return false;
                    if (this.asociacionFinalizada) return false;
                    return item?.tipo_mime === 'Eliminada' || item?.estado_revision === 'descartada';
                },
                redigitalizarRegistro(item) {
                    if (!this.canRedigitalizarRegistro(item)) {
                        this.$bvToast.toast(this.asociacionFinalizada
                            ? 'La asociación está finalizada. No se pueden reactivar fichas.'
                            : 'Esta ficha no está descartada/eliminada.', {
                            title: 'Acción no permitida',
                            variant: 'warning',
                            solid: true
                        });
                        return;
                    }

                    this.$bvModal.msgBoxConfirm('¿Reactivar esta ficha para digitalizarla nuevamente?', {
                        title: 'Reactivar ficha',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: 'Sí, reactivar',
                        cancelTitle: 'Cancelar',
                        footerClass: 'p-2',
                        centered: true
                    }).then(value => {
                        if (!value) return;
                        axios.post('/api/reactivar_imagen_digitalizada', { id: item.id })
                            .then((response) => {
                                this.$bvToast.toast(response.data?.message || 'Ficha reactivada.', {
                                    title: 'Digitalización habilitada',
                                    variant: 'success',
                                    solid: true
                                });
                                this.cargarImagenes();
                            })
                            .catch((error) => {
                                this.$bvToast.toast(error.response?.data?.message || 'No se pudo reactivar la ficha.', {
                                    title: 'Error',
                                    variant: 'danger',
                                    solid: true
                                });
                            });
                    });
                },
                canReenviarRegistro(item) {
                    if (!this.user) return false;
                    if (parseInt(this.user.id) !== 1) return false;
                    if (this.asociacionFinalizada) return false;
                    return item?.estado_revision === 'revisada_manual'
                        && item?.tipo_mime === 'Revisada'
                        && !!item?.imagen_trasera_id
                        && ['enviado_ok', 'duplicado'].includes(item?.estado_crm);
                },
                estaReenviando(id) {
                    return Boolean(this.reenviandoIds[id]);
                },
                reenviarImagen(item) {
                    if (!this.canReenviarRegistro(item)) {
                        this.$bvToast.toast('Solo se pueden reenviar fichas válidas con estado Exitoso.', {
                            title: 'Acción no permitida',
                            variant: 'warning',
                            solid: true
                        });
                        return;
                    }

                    this.$bvModal.msgBoxConfirm('¿Reenviar esta ficha al flujo normal de envío CRM?', {
                        title: 'Confirmar reenvío',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'info',
                        okTitle: 'Reenviar',
                        cancelTitle: 'Cancelar',
                        footerClass: 'p-2',
                        centered: true
                    }).then((value) => {
                        if (!value) return;

                        this.$set(this.reenviandoIds, item.id, true);
                        axios.post('/api/reenviar_imagen_crm', { id: item.id })
                            .then((response) => {
                                this.$bvToast.toast(response.data?.message || 'Ficha marcada para reenvío.', {
                                    title: 'Reenvío programado',
                                    variant: 'success',
                                    solid: true
                                });
                                this.cargarImagenes();
                            })
                            .catch((error) => {
                                this.$bvToast.toast(error.response?.data?.message || 'Error al reenviar la ficha.', {
                                    title: 'Error',
                                    variant: 'danger',
                                    solid: true
                                });
                            })
                            .finally(() => {
                                this.$delete(this.reenviandoIds, item.id);
                            });
                    });
                },
                // para una fila (entry) devuelve la imagen impar correspondiente (la anterior en filteredData)
                oddImageUrlByOrigIndex(origIndex) {
                    const prevIndex = origIndex - 1;
                    if (prevIndex < 0) return null;
                    const prev = this.filteredData[prevIndex];
                    return prev ? prev.url_publica : null;
                },
                reprocesarImagen(id) {
                    if (this.asociacionFinalizada) {
                        this.$bvToast.toast('La asociación está finalizada. No se puede reprocesar fichas.', {
                            title: 'Acción bloqueada',
                            variant: 'warning',
                            solid: true
                        });
                        return;
                    }
                    this.$set(this.reprocesandoIds, id, true);
                    axios.post('/api/reprocesar_imagen_s3', { id_imagen: id })
                        .then((res) => {
                            this.$bvToast.toast(res.data?.message || 'Actualizado desde S3.', {
                                title: 'Reprocesado', variant: 'success', solid: true
                            });
                            this.cargarImagenes();
                        })
                        .catch((err) => {
                            this.$bvToast.toast(err.response?.data?.message || 'Sin resultado en S3 para este registro.', {
                                title: 'Sin datos', variant: 'warning', solid: true
                            });
                        })
                        .finally(() => { this.$delete(this.reprocesandoIds, id); });
                },
                reprocesarPendientes() {
                    if (this.asociacionFinalizada) {
                        this.$bvToast.toast('La asociación está finalizada. No se puede reprocesar fichas.', {
                            title: 'Acción bloqueada',
                            variant: 'warning',
                            solid: true
                        });
                        return;
                    }
                    this.reprocesandoTodos = true;
                    axios.post('/api/reprocesar_pendientes_evento', {
                        evento_id:    this.evento_id,
                        laborante_id: this.laborante_id
                    })
                        .then((res) => {
                            this.$bvToast.toast(res.data?.message || 'Listo.', {
                                title: 'Reprocesado masivo', variant: 'success', solid: true
                            });
                            this.cargarImagenes();
                        })
                        .catch(() => {
                            this.$bvToast.toast('Error al reprocesar pendientes.', {
                                title: 'Error', variant: 'danger', solid: true
                            });
                        })
                        .finally(() => { this.reprocesandoTodos = false; });
                },
                    crmEstadoTexto(estado) {
                        switch (estado) {
                            case 'enviado_ok':
                                return 'Exitoso';
                            case 'duplicado':
                                return 'Duplicado';
                            case 'reenviado_admin_exitoso':
                                return 'Reenviado admin exitoso';
                            case 'reenviado_admin_duplicado':
                                return 'Reenviado admin duplicado';
                            case 'reenviado_admin_error':
                                return 'Reenviado admin con error';
                            case 'error_envio':
                                return 'Con error';
                            case 'pendiente_envio':
                            case 'pendiente_envio_admin':
                            case 'pendiente_reenvio':
                            case 'reenvio_programado':
                                return estado === 'pendiente_envio_admin' ? 'Pendiente admin' : 'Pendiente';
                            case 'sin_preparar':
                                return 'Sin preparar';
                            case 'no_aplica':
                                return 'No aplica';
                            default:
                                return estado ? estado : 'Sin estado';
                        }
                    },
                    crmDescripcionLarga(estado) {
                        const map = {
                            'sin_preparar':             'A la espera de revisión',
                            'enviado_ok':               'Enviado exitosamente al CRM',
                            'duplicado':                'Registro duplicado en CRM',
                            'reenviado_admin_exitoso':  'Reenviado por admin — exitoso',
                            'reenviado_admin_duplicado':'Reenviado por admin — duplicado',
                            'reenviado_admin_error':    'Reenviado por admin — con error',
                            'error_envio':              'Error por respuesta del CRM',
                            'pendiente_envio':          'Pendiente de envío al CRM',
                            'pendiente_envio_admin':    'Pendiente de envío (admin)',
                            'pendiente_reenvio':        'Pendiente de reenvío',
                            'reenvio_programado':       'Reenvío programado',
                            'no_aplica':                'No se envió al CRM',
                        };
                        return map[estado] || (estado || 'Sin estado');
                    },
                    crmEstadoVariant(estado) {
                        switch (estado) {
                            case 'enviado_ok':
                                return 'success';
                            case 'duplicado':
                                return 'warning';
                            case 'reenviado_admin_exitoso':
                                return 'success';
                            case 'reenviado_admin_duplicado':
                                return 'warning';
                            case 'reenviado_admin_error':
                                return 'danger';
                            case 'error_envio':
                                return 'danger';
                            case 'pendiente_envio':
                            case 'pendiente_envio_admin':
                            case 'pendiente_reenvio':
                            case 'reenvio_programado':
                                return 'info';
                            case 'no_aplica':
                                return 'dark';
                            default:
                                return 'secondary';
                        }
                    },
    },
    watch: {
        // resetear página al cambiar filtro o perPage
        /*filtro() {
            this.currentPage = 1;
        },
        perPage() {
            this.currentPage = 1;
        }*/
    },
    created(){
        this.asociacionFinalizada = Boolean(this.asociacion_finalizada);
        this.cargarImagenes();

    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-alert v-if="accionesBloqueadasPorFinalizado" show variant="warning" class="mb-3">
            Esta asociación está finalizada. Las fichas quedan en modo solo lectura y no se pueden modificar, eliminar ni reactivar.
        </b-alert>
        <div class="row">
            <loading-message v-if="isLoading" />
            <div class="col-12">
                <div class="card mb-3">
                    <div class="card-body py-2">
                        <div class="d-flex flex-wrap align-items-center header-chip-row">
                            <span class="badge badge-primary header-chip">Evento: {{ evento_codigo || ('ID ' + evento_id) }}</span>
                            <span class="badge badge-info header-chip">Coordinador: {{ coordinador_evento || 'No informado' }}</span>
                            <b-button
                                size="sm"
                                variant="success"
                                class="ml-auto"
                                :href="`/web/digitalizar/encuesta/${evento_id}/${laborante_id}`"
                                v-if="!accionesBloqueadasPorFinalizado"
                            >
                                <i class="bx bx-edit"></i> Digitalizar
                            </b-button>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="listado-toolbar">
                            <div class="listado-toolbar-top">
                                <div id="tickets-table_length" class="dataTables_length d-flex align-items-center flex-wrap">
                                    <label class="d-inline-flex align-items-center mb-0">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;
                                        <span v-if="filtro && visibleData.length !== allFichas.length"><strong>{{ visibleData.length }}</strong> de {{ allFichas.length }} registros</span>
                                        <span v-else><strong>{{ allFichas.length }}</strong> registros</span>
                                    </label>
                                </div>
                                <div id="tickets-table_filter" class="dataTables_filter">
                                    <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar por nombre, rut, RBD, establecimiento, correo..."
                                        class="form-control form-control-sm listado-search"
                                    ></b-form-input>
                                </div>
                            </div>

                            <div class="crm-tags" aria-label="Resumen CRM">
                                <span
                                    v-for="r in crmResumen"
                                    :key="r.key"
                                    class="badge crm-tag"
                                    :class="`badge-${r.variant}`"
                                    :title="r.title"
                                >{{ r.label }}: {{ r.count }}</span>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 4%;">Nº</th>
                                        <th style="width: 6%;">Ficha</th>
                                        <th style="width: 6%;">Ficha 2</th>
                                        <th style="width: 30%;">Estado</th>
                                        <th style="width: 14%;">Estado CRM</th>
                                        <th style="width: 30%;">Nombre</th>
                                        <th style="width: 10%;">Rut</th>
                                        <th style="width: 8%;">RBD</th>
                                        <th style="width: 10%;">Fecha nacimiento</th>
                                        <th style="width: 10%;">Establecimiento</th>
                                        <th style="width: 10%;">Telefono</th>
                                        <th style="width: 10%;">Correo</th>
                                        <th style="width: 10%;">Curso</th>
                                        <th style="width: 10%;">Carrera</th>
                                        <th style="width: 20%;" v-if="user.rol!='Laborante' && !accionesBloqueadasPorFinalizado">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(entry, index) in paginatedData" :key="entry.item.id || entry.origIndex" >
                                        <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                                        <!-- v2: una sola celda (colspan=2) con el PDF completo (frontal + trasera). -->
                                        <td v-if="Number(entry.item.formulario_version || 1) === 2" colspan="2" class="text-center">
                                            <div
                                                v-if="entry.item.pdf_url_full || entry.item.pdf_url"
                                                style="width:60px;height:60px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #ddd;border-radius:4px;cursor:pointer;background:#f8f9fa;"
                                                title="Ver ficha (frontal + trasera)"
                                                @click="abrirModalImagen(entry.item.pdf_url_full || entry.item.pdf_url)"
                                            >
                                                <i class="bx bxs-file-pdf" style="font-size:32px;color:#d93025;"></i>
                                            </div>
                                            <span v-else class="text-muted">—</span>
                                            <div
                                                v-if="entry.item.pdf_pagina_frontal"
                                                class="text-muted mt-1"
                                                style="font-size:0.7rem; line-height:1.1;"
                                            >
                                                p. {{ entry.item.pdf_pagina_frontal }}<span v-if="entry.item.pdf_pagina_trasera">–{{ entry.item.pdf_pagina_trasera }}</span>
                                            </div>
                                            <div
                                                v-if="entry.item.pdf_filename"
                                                class="text-muted text-truncate"
                                                :title="entry.item.pdf_filename"
                                                style="font-size:0.7rem; line-height:1.1; max-width:130px; margin:0 auto;"
                                            >{{ entry.item.pdf_filename }}</div>
                                        </td>
                                        <!-- v3: cada página es una ficha frontal independiente. -->
                                        <td v-if="Number(entry.item.formulario_version || 1) === 3" colspan="2" class="text-center">
                                            <img
                                                :src="entry.item.url_publica"
                                                alt="Ficha frontal"
                                                style="max-width: 60px; max-height: 60px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                                                @click="abrirModalImagen(entry.item.url_publica)"
                                                loading="lazy"
                                            />
                                        </td>
                                        <!-- v1: comportamiento original con dos celdas (Img + Img 2). -->
                                        <td v-if="Number(entry.item.formulario_version || 1) === 1">
                                        <template v-if="esPdfUrl(entry.item.url_publica)">
                                            <div
                                                style="width:60px;height:60px;display:flex;align-items:center;justify-content:center;border:1px solid #ddd;border-radius:4px;cursor:pointer;background:#f8f9fa;"
                                                title="Ver PDF"
                                                @click="abrirModalImagen(entry.item.url_publica)"
                                            >
                                                <i class="bx bxs-file-pdf" style="font-size:32px;color:#d93025;"></i>
                                            </div>
                                        </template>
                                        <img
                                            v-else
                                            :src="entry.item.url_publica"
                                            alt="Imagen"
                                            style="max-width: 60px; max-height: 60px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                                            @click="abrirModalImagen(entry.item.url_publica)"
                                            loading="lazy"
                                        />
                                        </td>
                                        <td v-if="Number(entry.item.formulario_version || 1) === 1">
                                            <img
                                                :src="entry.item.imagen2"
                                                alt="Imagen impar"
                                                style="max-width: 60px; max-height: 60px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                                                @click="abrirModalImagen(entry.item.imagen2)"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td>
                                            {{ entry.item.tipo_mime }}
                                            <br v-if="user && user.id === 1">
                                            <small v-if="user && user.id === 1" class="text-muted">#{{ entry.item.id }}</small>
                                        </td>
                                        <td>
                                            <span class="badge" :class="`badge-${crmEstadoVariant(entry.item.estado_crm)}`">
                                                {{ crmEstadoTexto(entry.item.estado_crm) }}
                                            </span>
                                            <span
                                                v-if="entry.item.ultimo_error_crm && ['error_envio','reenviado_admin_error','no_aplica'].includes(entry.item.estado_crm)"
                                                :title="entry.item.ultimo_error_crm"
                                                style="cursor:help; margin-left:3px; color:#888; font-size:0.85em;"
                                            ><i class="bx bx-info-circle"></i></span>
                                        </td>
                                        <td>{{ entry.item.nombre_completo }}</td>
                                        <td>{{ entry.item.rut }}</td>
                                        <td>{{ entry.item.rbd_colegio || entry.item.rbd || '-' }}</td>
                                        <td>{{ entry.item.fecha }}</td>
                                        <td>{{ entry.item.establecimiento }}</td>
                                        <td>{{ entry.item.celular }}</td>
                                        <td>{{ entry.item.email }}</td>
                                        <td>{{ entry.item.curso }}</td>
                                        <td>{{ entry.item.carrera }}</td>
                                        <td v-if="user.rol!='Laborante' && !accionesBloqueadasPorFinalizado">
                                            <b-button
                                                v-if="user && user.id === 1 && entry.item.tipo_mime === 'Pendiente' && Number(entry.item.formulario_version || 1) !== 2 && !asociacionFinalizada"
                                                variant="warning"
                                                size="sm"
                                                class="mr-1"
                                                :disabled="Boolean(reprocesandoIds[entry.item.id])"
                                                @click="reprocesarImagen(entry.item.id)"
                                            >
                                                <i class="bx bx-refresh"></i> {{ reprocesandoIds[entry.item.id] ? '...' : 'S3' }}
                                            </b-button>
                                            <b-button
                                                v-if="canReenviarRegistro(entry.item)"
                                                variant="info"
                                                size="sm"
                                                class="mr-1"
                                                :disabled="estaReenviando(entry.item.id)"
                                                @click="reenviarImagen(entry.item)"
                                            >
                                                <i class="bx bx-refresh"></i> {{ estaReenviando(entry.item.id) ? 'Reenviando...' : 'Reenviar' }}
                                            </b-button>
                                            <b-button
                                                variant="primary"
                                                size="sm"
                                                class="mr-1"
                                                v-if="canRedigitalizarRegistro(entry.item)"
                                                @click="redigitalizarRegistro(entry.item)"
                                            >
                                                <i class="bx bx-edit"></i> Digitalizar
                                            </b-button>
                                            <b-button variant="danger" size="sm" v-if="entry.item.tipo_mime != 'Eliminada' && !asociacionFinalizada" @click="eliminarImagen(entry.item.id)">
                                                <i class="bx bx-trash"></i> Eliminar
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal v-model="showModalImagen" size="lg" title="Imagen" hide-footer>
          <div v-if="!esPdfUrl(modalImagenUrl)" class="d-flex justify-content-center mb-3 gap-2">
            <b-button variant="primary" @click="rotarModalIzquierda">
              <i class="bx bx-rotate-left"></i> Izquierda
            </b-button>
            <b-button variant="primary" @click="rotarModalDerecha">
              <i class="bx bx-rotate-right"></i> Derecha
            </b-button>
          </div>
          <iframe
            v-if="esPdfUrl(modalImagenUrl)"
            :src="modalImagenUrl"
            style="width: 100%; height: 80vh; border: 0;"
          ></iframe>
          <img v-else :src="modalImagenUrl" alt="Imagen ampliada" style="width: 100%; max-height: 80vh; object-fit: contain;"
            :style="{ transform: 'rotate(' + modalRotacion + 'deg)' }" />
        </b-modal>
    </Layout>
</template>

<style scoped>
.header-chip-row {
    gap: 12px;
}

.header-chip {
    padding: 0.45rem 0.65rem;
    font-size: 0.78rem;
    font-weight: 600;
}

.listado-toolbar {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.listado-toolbar-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
}

.listado-search {
    width: 360px;
    max-width: 100%;
}

.crm-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.crm-tag {
    cursor: help;
    font-size: 0.78rem;
    line-height: 1;
    padding: 0.35rem 0.45rem;
}

@media (max-width: 768px) {
    .header-chip-row .ml-auto {
        margin-left: 0 !important;
        width: 100%;
    }

    .listado-search {
        width: 100%;
    }

    .listado-toolbar-top {
        align-items: stretch;
    }
}
</style>
